import React from 'react'
import SVG from 'react-inlinesvg'
import {toAbsoluteUrl} from '../AssetHelpers'

type Props = {
  className?: string
  path: string
  svgClassName?: string
  small?: boolean
  style?: any
}

const KTSVG: React.FC<Props> = React.memo(
  ({className = '', path, svgClassName = 'mh-50px', small = true, style = null}) => {
    return (
      <span className={`${small ? 'svg-icon' : ''} ${className}`}>
        <SVG src={toAbsoluteUrl(path)} className={svgClassName} style={style} />
      </span>
    )
  }
)
KTSVG.displayName = 'KTSVG'

export {KTSVG}
